import {ConfigObjectType} from '@wallaby-ui/core';
import * as React from 'react';

import {SettingsLayout} from './SettingsLayout';

interface OwnProps {
  config: ConfigObjectType;
}

type Props = OwnProps;

export const SettingsLayoutContainer: React.FC<Props> = (props) => {
  const {config} = props;
  return <SettingsLayout {...props} config={config} />;
};
